const actions = {
  SET_STATE: "widget/SET_STATE",
  LIST: "widget/LIST",
  CREATE: "widget/CREATE",
  DETAIL: "widget/DETAIL",
  UPDATE: "widget/UPDATE",
  DELETE: "widget/DELETE",
  CHANGE_INDEX: "widget/CHANGE_INDEX",
  UPDATE_GRIDS_LAYOUT: "widget/UPDATE_GRIDS_LAYOUT",
};

export default actions;
